import React, { useState, useRef, useEffect } from "react";
import Header from "../../commons/Header/Header";
import Sidebar from "../../commons/Sidebar/Sidebar";
import Star from "../../assets/images/icons/star.svg";
import Girl from "../../assets/images/girl.jpg";
import FilterIcon from "../../assets/images/icons/filter-icon.svg";
import DownArrow from "../../assets/images/icons/arrow-ios-down-white.svg";
import { Link, useNavigate } from "react-router-dom";
import { handleApiCall } from "../../apis";
import { endpoints } from "../../utils/endpoints";
import viewImage from "../../assets/images/icons/view.svg";


function Notification() {
  const [openSettings, setOpenSettings] = useState(false);
  const [openOptions, setOpenOptions] = useState(false);
  const [selected, setSelected] = useState("All Notification");
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [limit] = useState(10);

  const settingsRef = useRef(null);
  const optionsRef = useRef(null);

  const [toggles, setToggles] = useState({
    all: false,
    info: false,
    warning: false,
    high: false,
    danger: false,
  });
  const navigate = useNavigate();
  const handleViewReceivers = (notification) => {
    navigate("/notification-receivers", { state: { notification } });
  };

  const handleToggle = (key) => {
    setToggles((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  const handleSelect = (option) => {
    setSelected(option);
    setOpenOptions(false);
  };

  // Format date helper function
  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    const date = new Date(dateString);
    const options = { day: "numeric", month: "short", year: "numeric" };
    return date.toLocaleDateString("en-GB", options);
  };

  // Fetch notifications
  const fetchNotifications = async () => {
    setLoading(true);
    try {
      const params = new URLSearchParams({
        page: page,
        limit: limit,
      });
      const response = await handleApiCall("get", `${endpoints.notificationList}?${params.toString()}`);

      console.log("Notification API Response:", response?.data);

      if (response?.data?.code === 200) {
        setNotifications(response?.data?.data || []);
      }
    } catch (error) {
      console.error("Error fetching notifications:", error);
    } finally {
      setLoading(false);
    }
  };

  // Fetch notifications on component mount
  useEffect(() => {
    fetchNotifications();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page]);

  // Close dropdowns when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (settingsRef.current && !settingsRef.current.contains(event.target)) {
        setOpenSettings(false);
      }
      if (optionsRef.current && !optionsRef.current.contains(event.target)) {
        setOpenOptions(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="container-scroller">
      <Header />
      <div className="container-fluid page-body-wrapper">
        <Sidebar />
        <div className="main-panel">
          <div className="content-wrapper">
            <div className="heading mb-3 d-flex align-items-center">
              <h3 className="text-default weight-400 my-0">Notification</h3>
              <div style={{ display: "flex", gap: "20px", alignItems: "center" }} className="ml-auto">
                <Link to="/add-notification" className="btn btn-primary rounded-2 px-4">
                  Add Notifaction
                </Link>
                {/* Settings Dropdown */}
                {/* <div style={{ position: "relative" }} ref={settingsRef}>
                  <button
                    onClick={() => {
                      setOpenSettings(!openSettings);
                      setOpenOptions(false); // close other dropdown
                    }}
                    style={{
                      background: "none",
                      border: "none",
                      cursor: "pointer",
                      fontSize: "20px",
                    }}
                  >
                    ⚙️
                  </button>

                  {openSettings && (
                    <div
                      style={{
                        position: "absolute",
                        top: "120%",
                        right: 0,
                        background: "rgb(54 54 55)",
                        border: "1px solid rgb(118 118 118)",
                        borderRadius: "8px",
                        padding: "2px 16px",
                        color: '#fff',
                        width: "220px",
                        boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
                        zIndex: 1000,
                      }}
                    >
                      {[
                        { key: "all", label: "All Notification" },
                        { key: "info", label: "Information" },
                        { key: "warning", label: "Warning" },
                        { key: "high", label: "High" },
                        { key: "danger", label: "911 Danger" },
                      ].map((item) => (
                        <div
                          key={item.key}
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            margin: "16px 0",
                          }}
                        >
                          <span>{item.label}</span>
                          <label className="my-0"
                            style={{ position: "relative", width: "40px", height: "20px" }}
                          >
                            <input
                              type="checkbox"
                              checked={toggles[item.key]}
                              onChange={() => handleToggle(item.key)}
                              style={{ display: "none" }}
                            />
                            <span
                              style={{
                                position: "absolute",
                                cursor: "pointer",
                                top: 0,
                                left: 0,
                                right: 0,
                                bottom: 0,
                                backgroundColor: toggles[item.key] ? "#26a1f5" : "#999",
                                borderRadius: "20px",
                                transition: "0.3s",
                              }}
                            />
                            <span
                              style={{
                                position: "absolute",
                                height: "16px",
                                width: "16px",
                                left: toggles[item.key] ? "22px" : "2px",
                                bottom: "2px",
                                backgroundColor: "white",
                                borderRadius: "50%",
                                transition: "0.3s",
                              }}
                            />
                          </label>
                        </div>
                      ))}
                    </div>
                  )}
                </div> */}

                {/* Options Dropdown */}
                {/* <div style={{ position: "relative" }} ref={optionsRef}>
                  <button
                    onClick={() => {
                      setOpenOptions(!openOptions);
                      setOpenSettings(false); // close other dropdown
                    }}
                    className="btn btn-primary rounded-2 px-3"
                  >
                    {selected}{" "}
                    <span className="ml-2">
                      <img src={DownArrow} alt="▼" style={{ width: "12px" }} />
                    </span>
                  </button>

                  {openOptions && (
                    <ul
                      style={{
                        position: "absolute",
                        top: "100%",
                        right: 0,
                        listStyle: "none",
                        margin: 0,
                        padding: "6px 0",
                        border: "1px solid rgba(255,255,255,.4)",
                        borderRadius: "6px",
                        background: "#363637",
                        color: "#fff",
                        width: "200px",
                        boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
                        zIndex: 1000,
                      }}
                    >
                      {options.map((option, i) => (
                        <li
                          key={i}
                          onClick={() => handleSelect(option)}
                          style={{
                            padding: "8px 12px",
                            cursor: "pointer",
                            transition: "background 0.2s",
                          }}
                          onMouseEnter={(e) => (e.currentTarget.style.background = "#27a4f5")}
                          onMouseLeave={(e) => (e.currentTarget.style.background = "transparent")}
                        >
                          {option}
                        </li>
                      ))}
                    </ul>
                  )}
                </div> */}
              </div>
            </div>
            <div className="review_wrapper">
              {loading ? (
                <div className="text-center py-5">
                  <div className="spinner-border text-primary" role="status">
                    <span className="sr-only">Loading...</span>
                  </div>
                </div>
              ) : notifications.length === 0 ? (
                <div className="text-center py-5 text-white">
                  <p>No notifications found</p>
                </div>
              ) : (
                notifications.map((notification, index) => (
                  
                //   <div key={notification._id || index} className="p-3 border-1 rounded-14 mt-4 border-left-solid card">
                //     <div className="d-flex justify-content-between align-items-start">
                      // <div className="d-flex align-items-center">
                      //   <div className="d-flex flex-column">
                      //     <div className="fw-bold">{notification?._id?.title || "N/A"}</div>
                      //   </div>
                      // </div>
                //       {/* <div className="small fw-semibold">{formatDate(notification.createdAt)}</div> */}
                //       <div className="small fw-semibold left">User Type : {notification?._id?.user_type}</div>
                //       <div className="d-flex flex-column align-items-end">
                //         <div className="small fw-semibold">{formatDate(notification.createdAt)}</div>
                //         <button className="btn btn-sm btn-outline-primary mt-2 d-flex align-items-center justify-content-center" 
                //           style={{ width: "35px", height: "35px", borderRadius: "50%" }}
                //           onClick={() => handleViewReceivers(notification)}
                //           title="View Receivers"
                //         >
                //           <i className="fa fa-eye" aria-hidden="true"></i>
                //         </button>
                //       </div>
                      
                //     </div>
                //     <div className="mt-2" style={{ fontSize: "14px", lineHeight: "1.5" }}>
                //       {notification?._id?.description ||
                //         "Lorem Ipsum, Or Lipsum As It Is Sometimes Know Lorem Ipsum, Or Lipsum As It Is Sometime This Lorem Ipsum, Or Lipsum As It Is Sometime On Lorem Ipsum, Or Lipsum As It Is Sometimes Know Lorem Ipsum, Or Lipsum As It Is Sometime This Lorem Ipsum, Or Lipsum As It Is Sometime On"}
                //     </div>
                //     {/* <div className="d-flex flex-column"> Action</div> */}
                //   </div>
                // ))
                // notifications.map((notification, index) => (
                <div
                  key={notification._id || index}
                  className="p-3 border-1 rounded-14 mt-4 border-left-solid card"
                >
                <div className="d-flex justify-content-between align-items-center mb-1">
                  <div className="fw-bold" style={{ fontSize: "16px", flex: 2 }}>
                    {notification?._id?.title || "N/A"}
                  </div>
                  <div
                    className="small fw-semibold text-right"
                    style={{ flex: 1, fontSize: "13px" }}
                  >
                    User Type:  {notification?._id?.user_type || "N/A"} | {formatDate(notification.createdAt)}
                  </div>
                </div>

                  {/* === Description + Action === */}
                  <div className="d-flex justify-content-between align-items-center mt-2">
                    <div
                      style={{
                        flex: 3,
                        fontSize: "14px",
                        lineHeight: "1.6",
                      }}
                    >
                      {notification?._id?.description || "No description provided."}
                    </div>
                    <div style={{ flexShrink: 0, marginLeft: "20px" }}>
                      <div
                      className="d-flex align-items-center justify-content-center"
                        onClick={() => handleViewReceivers(notification)}
                        title="View Receivers"
                      >
                        <img src={viewImage} alt="View" />
                      </div>
                    </div>
                  </div>
                </div>
              ))
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Notification;
